const TermsAndConditionsApiUrls = {
  GET: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/terms-and-conditions/get`,
  ACCEPT: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/terms-and-conditions/accept`,
  CREATE: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/terms-and-conditions/create`,
  UPDATE: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/terms-and-conditions/update`,
  GET_TERMS_AND_CONDITIONS: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/terms-and-conditions/get-terms-and-conditions`,
  SET_INACTIVE: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/terms-and-conditions/set-active-inactive`,
  ACCEPT_TERMS_AND_CONDITIONS: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/terms-and-conditions/accept-terms-and-conditions`,
  CHECK_TERMS_AND_CONDITIONS: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/terms-and-conditions/check-terms-and-conditions`,
};

export default TermsAndConditionsApiUrls